import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Save, Copy } from "lucide-react";

export function PublicTab() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["vig-settings"], queryFn: async () => (await api.get("/vigilanza/settings")).data });
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF({ ...data, period_from: data.period_from || "", period_to: data.period_to || "" }); }, [data]);
  const saveMut = useMutation({
    mutationFn: async () => (await api.put("/vigilanza/settings", { ...f, period_from: f.period_from || null, period_to: f.period_to || null })).data,
    onSuccess: () => { toast.success("Impostazioni salvate"); qc.invalidateQueries({ queryKey: ["vig-settings"] }); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  if (!f) return null;
  const url = `${window.location.origin}/turni`;

  return (
    <Card className="p-5 mt-4 border border-stone-200 shadow-none rounded-xl space-y-4 max-w-2xl" data-testid="vig-public-settings">
      <div className="flex items-center gap-2 text-sm">
        <span className="font-mono text-stone-700 truncate">{url}</span>
        <Button size="sm" variant="outline" onClick={() => { navigator.clipboard.writeText(url); toast.success("Link copiato"); }} data-testid="vig-copy-link"><Copy size={12} className="mr-1"/> Copia</Button>
      </div>
      <label className="flex items-center gap-2 text-sm"><Switch checked={f.published} onCheckedChange={(v) => setF({ ...f, published: v })} data-testid="vig-published"/> Pagina pubblica attiva</label>
      <div><Label className="text-xs">Titolo</Label><Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="vig-title"/></div>
      <div><Label className="text-xs">Sottotitolo in alto</Label><Input value={f.eyebrow} onChange={(e) => setF({ ...f, eyebrow: e.target.value })} data-testid="vig-eyebrow"/></div>
      <div className="flex gap-3 flex-wrap">
        <div><Label className="text-xs">Periodo pubblicato: dal</Label><Input type="date" value={f.period_from} onChange={(e) => setF({ ...f, period_from: e.target.value })} data-testid="vig-period-from"/></div>
        <div><Label className="text-xs">al</Label><Input type="date" value={f.period_to} onChange={(e) => setF({ ...f, period_to: e.target.value })} data-testid="vig-period-to"/></div>
      </div>
      <p className="text-xs text-stone-500">Se non indichi il periodo, la pagina mostra 6 settimane dall'inizio del mese corrente.</p>
      <Button onClick={() => saveMut.mutate()} className="bg-[#1C352D] hover:bg-[#2a4a40]" data-testid="vig-save-settings"><Save size={14} className="mr-1"/> Salva</Button>
    </Card>
  );
}
